import { resetForm, updateValues } from '../formSlice'
import { useEffect, useRef, useState } from 'react'
import { submit as companySubmit } from './submit'
import useTranslation from 'hooks/useTranslation'
import CompaniesElement from './CompaniesElement'
import Submit from 'components/inputs/Submit'
import { useDispatch } from 'react-redux'
import { STATUS } from 'utils/constants'
import NewBtn from './NewBtn'
import Form from './Form'

const Companies = ({ menuRef, isDesktop, data, getData, companyIdx, setCompanyIdx, selectData }) => {
  const [status, setStatus] = useState(STATUS.idle)
  const [form, showForm] = useState(false)

  const buttonRef = useRef(null)

  const dispatch = useDispatch()
  const { t } = useTranslation()

  useEffect(() => {
    if (form && menuRef?.current) scroll(menuRef)
  }, [form, menuRef])

  const scroll = ref => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const submit = (body, id = '') => {
    const error = () => setStatus(STATUS.failed)
    const success = data => {
      setStatus(STATUS.succeed)
      dispatch(resetForm())
      showForm(false)

      body && !id && data ? selectData(data) : getData()
    }

    setStatus(STATUS.pending)
    companySubmit(body, id, success, error)
  }

  return (
    (form || data?.length === 0)
      ? <Form
        submit={submit}
        block={status === STATUS.pending}
        cancel={data?.length > 0
          ? () => showForm(false)
          : undefined}
      />
      : <>
        <div className='companies__list list'>
          {data.length > 0 && data.map((e, i) => <CompaniesElement
            key={i}
            data={e}
            selected={i === companyIdx}
            selectData={() => setCompanyIdx(idx => {
              if (idx !== i) scroll(buttonRef)
              return idx === i ? undefined : i
            })}
            edit={() => {
              dispatch(updateValues(e))
              showForm(true)
            }} />)}
          {isDesktop && <div
            className={`companies__element list__element --big --newCompany`}
            onClick={() => {
              showForm(true)
            }}>
            <div className='list__title'>
              <p className='center --gap1'>
                <i className='icon icon--plus' />
                <span>{t('form.addAnotherCompany')}</span>
              </p>
            </div>
          </div>}
        </div>

        {!isDesktop && <div className='companies__info'>
          <NewBtn
            newCompany
            action={() => {
              showForm(true)
            }} />

          <div className='companies__or'>{t('basic.or')}</div>
          <div ref={buttonRef}>
            <Submit
              text={t('basic.next')}
              action={() => selectData()}
              block={companyIdx === undefined} />
          </div>
        </div>}
      </>
  )
}

export default Companies